var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { RadioButtonInner } from './radio-button';
import { RadioInner } from './radio';
import ValidationTooltip from '../tooltip/validation-tooltip';
import { Color } from '../const/';
var RadioGroup = (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioGroup.prototype.render = function () {
        return (React.createElement(ValidationTooltip, { placement: this.props.toolTipPlacement || 'topLeft', visible: typeof this.props.invalidMessage === 'string' &&
                this.props.invalidMessage.length > 0, invalidMessage: this.props.invalidMessage, getTooltipContainer: this.props.getTooltipContainer },
            React.createElement(RadioWrap, { invalidMessage: this.props.invalidMessage }, this.props.children)));
    };
    return RadioGroup;
}(React.Component));
export default RadioGroup;
var RadioWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  label {\n    margin-right: 16px;\n  }\n\n  > label {\n    ", " {\n      border: ", ";\n    }\n\n    ", " {\n      border: ", ";\n    }\n  }\n"], ["\n  label {\n    margin-right: 16px;\n  }\n\n  > label {\n    ", " {\n      border: ",
    ";\n    }\n\n    ", " {\n      border: ",
    ";\n    }\n  }\n"])), RadioButtonInner, function (_a) {
    var invalidMessage = _a.invalidMessage;
    return invalidMessage && "2px solid " + Color.SOFT_RED;
}, RadioInner, function (_a) {
    var invalidMessage = _a.invalidMessage;
    return invalidMessage && "1px solid " + Color.SOFT_RED;
});
var templateObject_1;
//# sourceMappingURL=radio-group.js.map